import React from 'react';
import axios from 'axios';
import {withRouter} from "react-router-dom";
import renderHTML from 'react-render-html';

import Loading from "../../components/Loading/index";

class UserStoryPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: !!this.props.match.params.id,
    }
  }

  componentDidMount() {
    if (this.props.sessionData && this.props.sessionData.accessToken) {
      this.getUserStory();
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.sessionData && nextProps.sessionData.accessToken) {
      this.getUserStory();
    }
  }

  getUserStory() {
    if (this.props.match.params.id) {
      let loginToken = this.props.sessionData.accessToken;
      let config = {
        headers: {
          'Authorization': 'Bearer ' + loginToken
        }
      };
      axios.get(this.props.api.userStories + "/" + this.props.match.params.id, config)
        .then((response) => {
          if(!this._componentWillUnmount) {
            this.setState({
              ...response.data,
              loading: false
            });
          }
        }).catch((error) => {
        this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst téma!');
        this.props.history.push('/userStories');
        console.log('Axios error: ', error);
      });
    }
  }

  render () {

    let { userStoryName, userStoryText, userId, administratorName, administratorText, pictureUrl } = this.state;

    if (!userId) return null;

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>{`Téma ${userStoryName} od soutěžícího ${userId.firstname} ${userId.surname}${userId.nickname ? ` (${userId.nickname})` : ''}`}</h2>
          <div className="clearfix" />
        </div>
        {
          this.state.loading ?
            <div className="x-content">
              <Loading />
            </div> :
            <div className="x-content">
              <div className="row">
                <div className={`${pictureUrl ? 'col-sm-6' : 'col-sm-12'}`}>
                  <h4>Uživatelův popis tématu</h4>
                  <p>{userStoryText}</p>
                </div>
                {pictureUrl &&
                  <div className="col-sm-6">
                    <img className="img-thumbnail" style={{ float: 'right', maxHeight: "300px"}} src={`${__APIURL__}/${pictureUrl}`} alt="" />
                  </div>
                }
                <div className="clearfix" />
                <div className="ln-solid"/>
                <div className="row">
                  <div className="col-sm-12">
                    {administratorName && administratorText ?
                      <React.Fragment>
                        <h4>Zpracované téma</h4>
                        <h3>{administratorName}</h3>
                        {administratorText && renderHTML(administratorText)}
                      </React.Fragment>
                      : <p className="text-danger">Téma nebylo doposud zpracováno!</p>
                    }
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    );
  }
}

export default withRouter(UserStoryPreview);



/** WEBPACK FOOTER **
 ** ./src/containers/UserStories/UserStoryPreview.js
 **/